import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

export const getNewsEvent = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/news-event`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getNewsEventByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/news-event/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createNewsEvent = async (body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('col1_title_en', body.col1_title_en)
        formData.append('col1_title_th', body.col1_title_th)
        formData.append('col1_description_en', body.col1_description_en)
        formData.append('col1_description_th', body.col1_description_th)
        formData.append('col2_description_en', body.col2_description_en)
        formData.append('col2_description_th', body.col2_description_th)
        formData.append('col3_description_en', body.col3_description_en)
        formData.append('col3_description_th', body.col3_description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)
        if (body.col1_imgs.length > 0) {
            body.col1_imgs.forEach((col1_imgs, index) => {
                if (col1_imgs.file?.file) {
                    const blob = new Blob([col1_imgs.file.file], { type: col1_imgs.file.file.type });
                    const parts = col1_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col1_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col1_imgs.file.size
                    });
        
                    formData.append(`col1_imgs`, file);
                } else {
                    formData.append(`col1_imgs`, col1_imgs.file);
                }
            });
        }
        else{
            formData.append('col1_imgs', null)
        }

        if (body.col2_imgs.length > 0) {
            body.col2_imgs.forEach((col2_imgs, index) => {
                if (col2_imgs.file?.file) {
                    const blob = new Blob([col2_imgs.file.file], { type: col2_imgs.file.file.type });
                    const parts = col2_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col2_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col2_imgs.file.size
                    });
        
                    formData.append(`col2_imgs`, file);
                } else {
                    formData.append(`col2_imgs`, col2_imgs.file);
                }
            });
        }
        else{
            formData.append('col2_imgs', null)
        }

        if (body.col3_imgs.length > 0) {
            body.col3_imgs.forEach((col3_imgs, index) => {
                if (col3_imgs.file?.file) {
                    const blob = new Blob([col3_imgs.file.file], { type: col3_imgs.file.file.type });
                    const parts = col3_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col3_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col3_imgs.file.size
                    });
        
                    formData.append(`col3_imgs`, file);
                } else {
                    formData.append(`col3_imgs`, col3_imgs.file);
                }
            });
        }
        else{
            formData.append('col3_imgs', null)
        }

      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      for (let entry of formData.entries()) {
    }
      const response = await instance.post(`/api/mgr/news-event`, formData, {
        headers: headers,

      });
       
  
      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const updateNewsEventByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('col1_title_en', body.col1_title_en)
        formData.append('col1_title_th', body.col1_title_th)
        formData.append('col1_description_en', body.col1_description_en)
        formData.append('col1_description_th', body.col1_description_th)
        formData.append('col2_description_en', body.col2_description_en)
        formData.append('col2_description_th', body.col2_description_th)
        formData.append('col3_description_en', body.col3_description_en)
        formData.append('col3_description_th', body.col3_description_th)
        formData.append('publish_date', body.publish_date)
        formData.append('end_date', body.end_date)
        formData.append('active', body.active)
        if (body.col1_imgs.length > 0) {
            body.col1_imgs.forEach((col1_imgs, index) => {
                if (col1_imgs.file?.file) {
                    const blob = new Blob([col1_imgs.file.file], { type: col1_imgs.file.file.type });
                    const parts = col1_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col1_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col1_imgs.file.size
                    });
        
                    formData.append(`col1_imgs`, file);
                } else {
                    formData.append(`col1_imgs`, col1_imgs.file);
                }
            });
        }
        else{
            formData.append('col1_imgs', null)
        }

        if (body.col2_imgs.length > 0) {
            body.col2_imgs.forEach((col2_imgs, index) => {
                if (col2_imgs.file?.file) {
                    const blob = new Blob([col2_imgs.file.file], { type: col2_imgs.file.file.type });
                    const parts = col2_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col2_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col2_imgs.file.size
                    });
        
                    formData.append(`col2_imgs`, file);
                } else {
                    formData.append(`col2_imgs`, col2_imgs.file);
                }
            });
        }
        else{
            formData.append('imgs', null)
        }

        if (body.col3_imgs.length > 0) {
            body.col3_imgs.forEach((col3_imgs, index) => {
                if (col3_imgs.file?.file) {
                    const blob = new Blob([col3_imgs.file.file], { type: col3_imgs.file.file.type });
                    const parts = col3_imgs.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: col3_imgs.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: col3_imgs.file.size
                    });
        
                    formData.append(`col3_imgs`, file);
                } else {
                    formData.append(`col3_imgs`, col3_imgs.file);
                }
            });
        }
        else{
            formData.append('col3_imgs', null)
        }
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/news-event/${id}`, formData, {
            headers: headers,
        });

    
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deleteNewsEvent = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/news-event/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

export const pinnedNewsEvent = async (queryparams) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/news-event/topnews`, {
            headers:headers,
            params: {...queryparams}
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
}

export const createAndUpdatePinnedNews = async (id,queryparams, body) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
            };
            const response = await instance.post(`/api/mgr/news-event/topnews`, body, {
            headers: headers,
            params: { ...queryparams }
            });
        
            if (response.status === 200) {
            return response;
            } else {
            return null;
            }
    } catch (error) {
        Swal.fire({
        icon: "error",
        title: error.response.data.message,
        confirmButtonText: "OK",
        }).then((result) => {});
    }
};